import { Button } from '@getinapp/appetizer';
import { PhoneOutline } from '@styled-icons/evaicons-outline/PhoneOutline';
import { Email } from '@styled-icons/material/Email';
import { useAuth } from 'hooks/use-auth';
import { useTranslation } from 'react-i18next';
import { SESSION_EVENT } from 'utils/constants';
import { Event } from 'utils/helpers';
import { useLoginHook } from '../Login/hooks';
import { useLoginByEmailHook } from '../LoginByEmail/hooks';
import * as S from './styles';

type IFlowProps = 'email' | 'sms';

const gtagEventsObject = {
  email: 'getin_login_newuser_sendmail_click',
  sms: 'getin_login_newuser_sendsms_click',
};

export const ResendCode = () => {
  const { t } = useTranslation();
  const { proceedToLogin } = useLoginByEmailHook();
  const { proceedToLoginBySMS } = useLoginHook();
  const {
    isResendCodeOpen,
    session,
    handleIsOpenResendCodeModal,
    handleIsOpenCheckOTPCodeOpen,
    handleChangeStartedLoginByEmailOrSMS,
    handleIsOpenLoginModal,
    handleIsOpenLoginByEmailModal,
    startedLoginByEmailOrSMS,
  } = useAuth();
  const startedLoginByEmail =
    startedLoginByEmailOrSMS === SESSION_EVENT.LOGIN_BY_EMAIL;

  const handleClickBackButton = (flow: IFlowProps | null) => {
    Event.push(gtagEventsObject[flow as IFlowProps]);
    handleIsOpenResendCodeModal(false);

    if (flow === 'sms' && startedLoginByEmail) {
      handleIsOpenLoginModal(true);
      handleChangeStartedLoginByEmailOrSMS(null);
      return;
    }

    if (flow === 'email' && !startedLoginByEmail) {
      handleIsOpenLoginByEmailModal(true);
      handleChangeStartedLoginByEmailOrSMS(null);
      return;
    }

    if (startedLoginByEmail && session?.email) {
      proceedToLogin({
        email: session?.email,
      });
    } else {
      session?.phone && proceedToLoginBySMS(session?.phone);
    }

    handleIsOpenCheckOTPCodeOpen(true);
  };

  const handleCloseResendCodeModal = () => {
    handleChangeStartedLoginByEmailOrSMS(null);
    handleIsOpenResendCodeModal(false);
  };

  const handleResendCodeButtonChange = () => {
    handleIsOpenResendCodeModal(false);

    if (startedLoginByEmail) {
      return handleIsOpenLoginByEmailModal(true);
    }

    handleIsOpenLoginModal(true);
  };

  return (
    <S.Modal
      width="15%"
      title={<S.Title>{t('@ResendCode.resend-code')}</S.Title>}
      isOpen={isResendCodeOpen}
      onRequestClose={handleCloseResendCodeModal}
    >
      <S.Paragraph>
        {startedLoginByEmail
          ? t('@ResendCode.we-send-to-email', {
              email: session?.email,
            })
          : t('@ResendCode.we-send-to-sms', {
              phone: session?.phone,
            })}
      </S.Paragraph>

      <S.Paragraph isVariant onClick={handleResendCodeButtonChange}>
        {t('@ResendCode.change')}
      </S.Paragraph>

      {/* @ts-ignore */}
      <Button
        type="button"
        isFullWidth
        variant="outline"
        loading={false}
        onClick={() => handleClickBackButton('sms')}
      >
        <PhoneOutline size={20} /> {t('@ResendCode.send-to-sms')}
      </Button>

      <S.LineBreak />

      {/* @ts-ignore */}
      <Button
        type="button"
        isFullWidth
        variant="outline"
        loading={false}
        onClick={() => handleClickBackButton('email')}
      >
        <Email size={20} /> {t('@ResendCode.send-to-email')}
      </Button>

      <S.BackButton onClick={() => handleClickBackButton(null)}>
        <span>{'<-'}</span>
        {t('@ResendCode.back')}
      </S.BackButton>
    </S.Modal>
  );
};
